<!--
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-19 09:59:56
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2025-01-08 11:03:44
 * @FilePath: src/views/index/header/index.vue
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 -->
<!--
  @Author 22030124/xieyq
  @Date 2023-12-04 09:29:48
  @Description 首页 =》头部组件
-->
<template>
  <header :class="[scope.clsPrefix, { active: appShow }]">
    <!-- 主体内容 -->
    <div :class="`${scope.clsPrefix}_body`">
      <!-- 图标 -->
      <span :class="`${scope.clsPrefix}_logo`" @click="clickHome">
        <img :src="logoUrl" alt="" />
        <img
          class="guoqing_gif"
          src="@/assets/imgs/logo.gif"
          height="60px"
          alt=""
        />
        <img
          class="newYear_gif"
          src="@/assets/imgs/newYearLogo.gif"
          height="60px"
          alt=""
        />
      </span>
      <!-- 工作台模式切换胶囊（仅当前工作台名称包含'数字人'时显示） -->
      <!-- v-if="currentWorkbench.name && (currentWorkbench.name.toLowerCase().includes('ceo') || currentWorkbench.name.toLowerCase().includes('cfo')  || currentWorkbench.name.toLowerCase().includes('cso'))" -->
      <div class="capsule-toggle" >
        <div
          class="capsule-option"
          :class="{ active: isClassicMode }"
          @click="switchWorkspace('normal')"
        >
          {{ $t('workbench.classicWorkbench') || '经典工作台' }}
        </div>
        <div class="capsule-divider">
          <img src="@/assets/imgs/swich_workbench.png" alt="" />
        </div>
        <div
          class="capsule-option"
          :class="{ active: isSmartMode }"
          @click="switchWorkspace('smart')"
        >
          {{ $t('workbench.smartWorkbench') || '智擎工作台' }}
        </div>
      </div>
      <!-- Cosmo Claw开关 -->
      <!-- <div
        v-if="userInfo.department != 'OPC' && smartPortal"
        :class="['smart-portal-switch', { active: isSmartPortalActive }]"
        @click="toggleSmartPortal"
      >
        <img
          src="@/assets/cosmo-claw.gif"
          :alt="$t('header.smartPortal')"
          class="switch-icon"
        />
        <span>{{ $t('header.smartPortal') }}</span>
      </div> -->
      <!-- 菜单 -->
      <!-- 搜索框 -->
      <!-- <div class="search-container search-container-apply" v-if="searchOpen">
        <div class="search-box">
          <div class="search-box-inner" id="search-box-inner">
            <el-input
              size="small"
              v-model="searchKeyword"
              :placeholder="
                aiChatMode
                  ? $t('search.askAI')
                  : $t('search.inputKeywordSearch')
              "
              @keyup.enter.native="handleSearch"
              clearable
              class="search-input"
              :class="{ 'ai-mode': aiChatMode }"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="handleSearch"
              ></el-button>
            </el-input>
            <div class="ai-switch-container">
              <div class="mode-label">
                {{
                  aiChatMode
                    ? $t('search.smartSearch')
                    : $t('search.normalSearch')
                }}
              </div>
              <div class="switch-wrapper">
                <el-switch
                  v-model="aiChatMode"
                  active-color="#4a5ff3"
                  inactive-color="#c0c4cc"
                  class="search-switch"
                ></el-switch>
                <span
                  class="ai-indicator"
                  :style="{ right: aiChatMode ? '2px' : 'calc(100% - 18px)' }"
                  >AI</span
                >
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </header>
</template>

<script>
// 引入配置获取函数
import { fetchAllConfigs } from '@/api/fetchConfig.js'
import { mapActions, mapState, mapGetters } from 'vuex' // 引入 mapActions 辅助函数
import { v4 as uuidv4 } from 'uuid'
import { getConfigByCode } from '@/api/setting'

export default {
  // 组件名称
  name: 'IndexHeader',
  // 提供
  provide() {
    return {
      // 容器
      con: this
    }
  },
  // 数据
  data() {
    return {
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'index-header'
      },
      // 是否显示app
      appShow: false,
      logoUrl: '', // 新增logoUrl
      // 搜索相关
      searchKeyword: '', // 搜索关键词
      searchPageMode: false, // 搜索模式：false-对话框，true-搜索页面
      searchPopoverVisible: false, // 搜索设置弹窗是否可见
      searchHistory: [], // 搜索历史记录
      aiChatMode: true, // AI聊天模式：true-AI聊天，false-普通搜索，默认开启
      searchOpen: true, // 搜索框是否显示
      smartPortal: false, // 智能门户开关是否显示
      loading: false, // 加载状态
      // Cosmo Claw开关状态
      smartPortalEnabled: false
    }
  },
  // 计算属性
  computed: {
    ...mapState('user', ['userInfo']),
    ...mapGetters(['currentWorkbench']),
    // 判断当前是否在Cosmo Claw页面
    isSmartPortalActive() {
      return this.$route.path.includes('cosmo-claw')
    },
    // 智擎工作台相关路由（/smart-engine 及子路由）
    isSmartWorkspaceRoute() {
      const path = this.$route.path
      return path.startsWith('/smart-engine') || path.includes('dashboard')
    },
    // 经典工作台模式（/ 恒为经典工作台）
    isClassicMode() {
      return this.$route.path === '/'
    },
    // 智擎工作台模式（/smart-engine 及 /dashboard 路由）
    isSmartMode() {
      const path = this.$route.path
      return path.startsWith('/smart-engine') || path.includes('dashboard')
    }
  },
  // 挂载完成
  created() {
    this.checkConfig()
  },
  mounted() {
    this.fetchConfigs()
    // 从 localStorage 加载历史搜索记录
    const savedHistory = localStorage.getItem('searchHistory')
    if (savedHistory) {
      try {
        this.searchHistory = JSON.parse(savedHistory)
      } catch (e) {
        console.error('解析搜索历史出错', e)
        this.searchHistory = []
      }
    }
  },
  methods: {
    // 检查搜索配置
    async checkConfig() {
      this.loading = true
      getConfigByCode({
        code: 'searchOpen'
      }).then((res) => {
        if (res.data?.configValue === 'true') {
          this.searchOpen = true
        } else {
          this.searchOpen = false
        }
        this.loading = false
      })
      getConfigByCode({
        code: 'smartPortal'
      }).then((res) => {
        if (res.data?.configValue === 'true') {
          this.smartPortal = true
        } else {
          this.smartPortal = false
        }
        this.loading = false
      })
    },
    // 添加初始化搜索配置的watcher
    watch: {
      searchOpen(newVal) {
        console.log('搜索框状态变化:', newVal)
      }
    },
    // 在mounted中也调用一次，确保初始化完成
    mounted() {
      this.fetchConfigs()
      // 从 localStorage 加载历史搜索记录
      const savedHistory = localStorage.getItem('searchHistory')
      if (savedHistory) {
        try {
          this.searchHistory = JSON.parse(savedHistory)
        } catch (e) {
          console.error('解析搜索历史出错', e)
          this.searchHistory = []
        }
      }
      // 确保搜索配置已加载
      if (!this.searchOpen) {
        this.checkSearchConfig()
      }
    },
    /**
     * 获取配置
     * @returns {void}
     */
    async fetchConfigs() {
      const configs = await fetchAllConfigs()
      if (configs) {
        const manageEndLogo = configs.manageEnd.find(
          (item) => item.code === 'manageEndLogo'
        )?.configValue
        const manageEndIco = configs.manageEnd.find(
          (item) => item.code === 'manageEndIco'
        )?.configValue
        const manageEndTitle = configs.manageEnd.find(
          (item) => item.code === 'manageEndTitle'
        )?.configValue
        const clientEndLogo = configs.clientEnd.find(
          (item) => item.code === 'clientEndLogo'
        )?.configValue
        const clientEndIco = configs.clientEnd.find(
          (item) => item.code === 'clientEndIco'
        )?.configValue
        const clientEndTitle = configs.clientEnd.find(
          (item) => item.code === 'clientEndTitle'
        )?.configValue

        this.updateManageEndLogo(manageEndLogo)
        this.updateManageEndIco(manageEndIco)
        this.updateManageEndTitle(manageEndTitle)
        this.updateClientEndLogo(clientEndLogo)
        this.updateClientEndIco(clientEndIco)
        this.updateClientEndTitle(clientEndTitle)

        this.$nextTick(() => {
          if (clientEndLogo) {
            this.logoUrl = clientEndLogo
          }
          if (clientEndTitle) {
            document.title = clientEndTitle
          }
          if (clientEndIco) {
            let link = document.querySelector("link[rel~='icon']")
            if (!link) {
              link = document.createElement('link')
              link.rel = 'icon'
              document.getElementsByTagName('head')[0].appendChild(link)
            }
            link.href = clientEndIco
          }
        })
      }
    },
    ...mapActions('config', [
      'updateClientEndLogo',
      'updateClientEndIco',
      'updateClientEndTitle',
      'updateManageEndLogo',
      'updateManageEndIco',
      'updateManageEndTitle'
    ]), // 映射 actions
    /**
     * 点击跳转到首页
     * @returns {void}
     */
    clickHome() {
      if (this.userInfo.department == 'OPC') {
        return
      }
      if (this.$route.path != '/') {
        window.open('/', '_self')
      }
    },
    /**
     * 点击菜单信息项
     * @param {*} itemData 信息项数据
     * @returns {void}
     */
    clickMenuItem(itemData) {
      this.$router.push({
        path: `/${itemData.meta.context || ''}/`
      })
    },
    /**
     * 点击应用
     * @returns {void}
     */
    clickApp() {
      this.$store.dispatch('app/updateShowAside', true)
    },
    /**
     * 处理搜索
     * @returns {void}
     */
    async handleSearch() {
      if (!this.searchKeyword.trim()) {
        this.$message.warning(this.$t('search.inputSearchKeyword'))
        return
      }

      const keyword = this.searchKeyword.trim()

      // 添加到历史记录
      this.addToSearchHistory(keyword)

      // 获取当前路由路径
      const currentPath = this.$route.path

      // 清空搜索框
      this.searchKeyword = ''

      try {
        // 如果当前已经在搜索结果页，直接更新查询参数
        if (currentPath === '/search') {
          await this.$router.push({
            path: '/search',
            query: {
              ...this.$route.query, // 保留现有查询参数
              keyword: keyword,
              type: this.$route.query.type || 'all' // 默认显示全部类型
            }
          })
        } else if (this.aiChatMode) {
          // AI聊天模式，跳转到aiChat页面
          const uuid = uuidv4()
          sessionStorage.setItem('keyword', keyword)
          await this.$router.push({
            path: `/chatAi/${uuid}`
          })
        } else {
          // 普通搜索模式，跳转到搜索结果页
          await this.$router.push({
            path: '/search',
            query: {
              keyword: keyword,
              type: 'all' // 默认显示全部类型
            }
          })
        }
      } catch (error) {
        console.error('Navigation error:', error)
      }
    },
    /**
     * 添加关键词到搜索历史
     * @param {string} keyword 搜索关键词
     * @returns {void}
     */
    addToSearchHistory(keyword) {
      const trimmedKeyword = keyword.trim()
      if (!trimmedKeyword) return

      // 置顶历史记录
      const index = this.searchHistory.indexOf(trimmedKeyword)
      if (index > -1) {
        // 如果已存在，先移除
        this.searchHistory.splice(index, 1)
      }

      // 添加到头部
      this.searchHistory.unshift(trimmedKeyword)

      // 限制最多存储10条记录
      if (this.searchHistory.length > 10) {
        this.searchHistory.pop()
      }

      // 保存到 localStorage
      localStorage.setItem('searchHistory', JSON.stringify(this.searchHistory))
    },
    /**
     * 清除搜索历史
     * @returns {void}
     */
    clearSearchHistory() {
      this.searchHistory = []
      localStorage.removeItem('searchHistory')
    },
    /**
     * 使用历史关键词
     * @param {string} keyword 历史关键词
     * @returns {void}
     */
    useHistoryKeyword(keyword) {
      this.searchKeyword = keyword
      this.handleSearch()
    },
    /**
     * 切换Cosmo Claw状态
     * @returns {void}
     */
    clearSmartWorkspaceQuery() {
      const query = { ...this.$route.query }
      delete query.agentId
      delete query.sessionKey
      const replacePromise = this.$router.replace({
        path: this.$route.path,
        query
      })
      if (replacePromise && replacePromise.catch) {
        replacePromise.catch(() => {})
      }
    },
    switchWorkspace(mode) {
      if (mode === 'smart') {
        this.$router.push('/smart-engine')
      } else {
        this.$router.push('/')
      }
    },
    toggleSmartPortal() {
      this.smartPortalEnabled = !this.smartPortalEnabled
      if (this.smartPortalEnabled) {
        // 跳转到子应用页面
        this.$router.push('/cosmo-claw')
      } else {
        // 跳回首页
        this.$router.push('/')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.guoqing_gif {
  display: none;
  margin-left: 30px;
  height: 40px !important;
}
.newYear_gif {
  display: none;
  margin-left: 30px;
  height: 40px !important;
}
// 组件样式
$class-prefix: 'index-header';

// 搜索容器样式
.nav-links {
  display: flex;
  margin-left: 20px;

  .nav-link {
    display: flex;
    align-items: center;
    padding: 0 15px;
    height: 50px;
    color: #606266;
    text-decoration: none;
    font-size: 14px;
    transition: all 0.3s;

    i {
      margin-right: 5px;
      font-size: 16px;
    }

    &:hover {
      color: #4a5ff3;
      background-color: rgba(74, 95, 243, 0.05);
    }

    &.router-link-exact-active {
      color: #4a5ff3;
      font-weight: 500;
    }
  }
}

.search-container {
  // margin-left: 30px;
  position: absolute !important;
  right: 700px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;

  .search-box {
    .search-box-inner {
      position: relative;
      display: flex;
      align-items: center;
    }

    .search-input {
      width: 350px;
      background: transparent;
      padding: 0 0 0 5px !important;
      border: none !important;
      .el-input__inner {
        background: transparent;
      }
    }

    .ai-switch-container {
      position: absolute;
      left: 12px;
      z-index: 1;
      display: flex;
      align-items: center;
      gap: 10px;

      .mode-label {
        position: absolute;
        left: 55px;
        font-size: 12px;
        color: #606266;
        white-space: nowrap;
        opacity: 0.9;
        transform: translateY(-1px);
        transition: all 0.3s ease;
      }

      .switch-wrapper {
        position: relative;
        display: inline-block;

        .search-switch {
          /* 开关样式 */
          .el-switch__core {
            border-radius: 10px;
          }
        }

        .ai-indicator {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background-color: #fff;
          color: #4a5ff3;
          font-size: 10px;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 1;
          z-index: 10;
          pointer-events: none;
          transition: right 0.3s ease;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
        }
      }

      @keyframes fadeIn {
        from {
          opacity: 0;
          transform: scale(0.8);
        }
        to {
          opacity: 1;
          transform: scale(1);
        }
      }
    }

    .el-input {
      .el-input__inner {
        height: 32px;
        line-height: 32px;
        padding-left: 140px;
        box-shadow: none;
        outline: none;
        transition: all 0.3s ease;
        background-color: #f9f9fc;
        border-radius: 4px;
      }

      &.ai-mode .el-input__inner {
        background-color: #f0f7ff;
      }

      &:hover .el-input__inner {
        background-color: #f0f2f7;
      }

      &.ai-mode:hover .el-input__inner {
        background-color: #e8f1fd;
      }

      &.is-focus .el-input__inner {
        border: none;
        box-shadow: none;
      }

      .el-input-group__append {
        background-color: #4a5ff3;
        border: none;
        color: #ffffff;
        padding: 0 15px;
        position: relative;
        transition: all 0.3s ease;

        // 移除分隔线

        .el-icon-search {
          color: #ffffff;
          font-size: 16px;
          position: relative;
        }

        &:hover {
          background-color: #5a6df5;
          transition: all 0.3s ease;
        }
      }
    }
  }

  .search-popover {
    &-header {
      border-bottom: 1px solid #ebeef5;
      padding-bottom: 10px;
      margin-bottom: 10px;
      font-weight: bold;
    }

    &-content {
      .search-mode-switch {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0;
      }

      .search-history {
        margin-top: 10px;

        &-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
        }

        &-list {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        &-item {
          display: inline-block;
          padding: 2px 8px;
          background-color: #f5f7fa;
          border-radius: 10px;
          font-size: 12px;
          cursor: pointer;

          &:hover {
            background-color: #e6e8eb;
          }
        }
      }
    }
  }
}

$class-prefix: 'index-header';

.#{$class-prefix} {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // background: linear-gradient(90deg, #F4F8FD 0%, #FFFFFF 100%);
  // box-shadow: inset 0px -1px 0px 0px #DDE1EF;
  z-index: 10;
  // 活跃状态
  &.active {
    box-shadow: inset 0px -1px 0px 0px #dde1ef, 0px 4px 25px 0px #e3e6eb;
    z-index: 4;
  }

  // 主体内容
  &_body {
    display: flex;
    align-items: center;
    flex: 1;
    position: relative;
  }

  // Cosmo Claw开关
  .smart-portal-switch {
    display: flex;
    align-items: center;
    background: #edf1fb;
    border: 1px solid #4a5ff3;
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 14px;
    color: #4a5ff3;
    margin-left: 20px;
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: #e3e9fb;
      box-shadow: 0 2px 4px rgba(74, 95, 243, 0.1);
    }

    &.active {
      background: #4a5ff3;
      color: #ffffff;
    }

    .switch-icon {
      position: absolute;
      left: -17px; // 调整位置使图片中间在div左边框上
      top: 40%;
      transform: translateY(-50%);
      width: 32px; // 根据实际图片大小调整
      height: 32px; // 根据实际图片大小调整
    }

    span {
      margin-left: 12px; // 为图片留出空间
    }
  }

  // logo
  &_logo {
    // width: 199px;
    // height: 26px;
    margin-left: 21px;
    cursor: pointer;
    display: flex;
    align-items: center;
    // background: url("@/assets/logo.png") center center / contain no-repeat;
    img {
      height: 26px;
    }
  }

  // 搜索框 - 保留旧样式以防需要回退
  &_search {
    margin-left: 30px;
    width: 400px;

    &_input {
      .el-input-group__prepend {
        background-color: #fff;
        border-color: #dcdfe6;
        padding: 0 10px;

        .el-switch__label {
          font-size: 12px;
        }
      }

      .el-input__inner {
        height: 36px;
        line-height: 36px;
      }

      .el-input-group__append {
        background-color: #4a5ff3;
        border-color: #4a5ff3;
        color: #fff;
        padding: 0 15px;

        .el-icon-search {
          color: #4a5ff3;
        }
      }
    }
  }

  // 菜单
  &_menu {
    display: flex;
    gap: 22px;
    align-items: center;
    margin-left: 68px;

    // 菜单信息项
    &_item {
      display: flex;
      align-items: center;
      gap: 6px;
      border: 1px solid transparent;
      padding: 0 12px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 32px;
      height: 32px;
      border-radius: 4px;
      cursor: pointer;
      background: #ffffff;
      position: relative;
      // 鼠标滑过
      &:hover,
      // 激活
      &.is-active {
        color: #fff;
        background: linear-gradient(270deg, #4a5ff3 0%, #4e86ff 100%);
        img {
          filter: brightness(20);
        }
      }

      // 箭头
      &_arrow {
        visibility: hidden;
        font-size: 14px;
      }

      &:hover &_arrow,
      // 激活
      &.is-active &_arrow {
        visibility: visible;
      }

      // 下拉箭头
      &_dropdown_link {
        visibility: hidden;
        color: #fff;
      }

      // 鼠标滑过显示
      &:hover &_dropdown_link,
      &.is-active &_dropdown_link {
        visibility: visible;
      }
    }
  }

  // 右侧
  &_right {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-right: 16px;

    .el-button + .el-button {
      margin-left: 0;
    }
  }

  // 设置按钮
  &_btn.el-button.is-circle {
    border: none;
    padding: 0;
    font-size: 14px;
    line-height: 24px;
    height: 24px;
    border-radius: 24px;

    // 鼠标滑过
    &:hover {
      color: #0057ff;
      background-color: transparent;
    }

    .iconfont {
      font-size: 14px;
    }

    // 搜索
    &.search {
      padding: 0 10px;

      &,
      &:hover {
        background-color: #f3f8fc;
      }
    }
  }

  &_badge {
    .el-badge__content {
      padding: 0;
      width: 16px;
      height: 16px;
      background: #ff2626;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #ffffff;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 14px;

      &.is-fixed {
        top: 2px;
      }
    }
  }

  // 下拉框
  &_dropdown {
    margin-left: 4px;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  // 下拉菜单
  &_dropdown_menu {
    color: #333333;
    position: absolute;
    top: 50px;
    right: 0;
    z-index: 1000;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 12px 12px; /* 根据需要调整 */

    // 菜单信息项
    &__item {
      padding: 10px 12px;
      height: 40px;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #1e2226;
      line-height: 20px;
      font-family: PingFangSC, PingFang SC;
      font-size: 14px;
      cursor: pointer;

      &:not(:last-child) {
        margin-bottom: 6px;
      }

      &.active,
      &:hover {
        color: #4a5ff3;
        background-color: #edf1fb;
        font-weight: 600;
      }
    }
  }

  .dropdown-enter-active,
  .dropdown-leave-active {
    transition: opacity 0.1s;
  }
  .dropdown-enter,
  .dropdown-leave-to {
    transition: opacity 0.1s;
    opacity: 0;
  }

  // 头像
  &_avatar {
    width: 32px;
    height: 32px;
    border-radius: 100%;
    cursor: pointer;
  }
}

@media screen and (max-width: 1440px) {
  .search-container-apply {
    margin: 0 !important;
    position: absolute;
    // left: calc(50% - 260px - 85px);
    // transform: translateX(-50%);
  }
}

// 语言切换器样式
.header-language-switcher {
  margin-left: 20px;
  margin-right: 10px;
}

// 工作台模式切换胶囊（居中）
.capsule-toggle {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 4px;
  user-select: none;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.capsule-option {
  padding: 6px 16px;
  border-radius: 4px;
  background: #f7f8fc;
  font-size: 14px;
  font-weight: 500;
  color: #4e5969;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.3s ease;
  &.active {
    background: #4a6cf7;
    color: #fff;
    box-shadow: 0 2px 6px rgba(74, 108, 247, 0.35);
  }
  &:not(.active):hover {
    color: #1d2129;
    background: #f7f8fa;
  }
}
.capsule-divider {
  display: flex;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
  justify-content: center;
  width: 16px;
  img {
    width: 16px;
    height: 16px;
    backdrop-filter: blur(2px);
    background: linear-gradient(270deg, hsla(0, 0%, 100%, 0.5), #fff);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 50%;
  }
}
</style>
